import { render, staticRenderFns } from "./yanbaotab.vue?vue&type=template&id=5cd773a4&scoped=true&"
import script from "./yanbaotab.vue?vue&type=script&lang=js&"
export * from "./yanbaotab.vue?vue&type=script&lang=js&"
import style0 from "./yanbaotab.vue?vue&type=style&index=0&id=5cd773a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd773a4",
  null
  
)

export default component.exports